import { render, staticRenderFns } from "./hospitalManage.vue?vue&type=template&id=1ae639a4"
import script from "./hospitalManage.vue?vue&type=script&lang=js"
export * from "./hospitalManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae639a4')) {
      api.createRecord('1ae639a4', component.options)
    } else {
      api.reload('1ae639a4', component.options)
    }
    module.hot.accept("./hospitalManage.vue?vue&type=template&id=1ae639a4", function () {
      api.rerender('1ae639a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/hospitalManage.vue"
export default component.exports